import ReactModal from "react-modal";
import "./style.scss";
import { motion, AnimatePresence } from "framer-motion";

const commonTransition = {
  duration: 0.2,
  type: "easeInOut",
};

const drawerAnimation = {
  fromTop: {
    hidden: { y: "-100%", opacity: 0 },
    visible: { y: 0, opacity: 1, transition: commonTransition },
    exit: { y: "-100%", opacity: 0, transition: commonTransition },
  },
  fromBottom: {
    hidden: { y: "100%", opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { ...commonTransition, duration: 0.1 },
    },
    exit: {
      y: "50%",
      opacity: 0,
      transition: { ...commonTransition, duration: 0.1 },
    },
  },
  fromRight: {
    hidden: { x: "100%", opacity: 0 },
    visible: { x: 0, opacity: 1, transition: commonTransition },
    exit: { x: "100%", opacity: 0, transition: commonTransition },
  },
};

const drawerClass = {
  base: "drawer",
  fromRight: "fromRight",
  fromTop: "fromTop",
  fromBottom: "fromBottom",
};

export default function Drawer({
  isOpen,
  onClose,
  onAfterClose,
  children,
  innerClass = "",
  from = "fromBottom",
}) {
  const handleToggleClass = () => {
    const layoutElement = document.querySelector("main");
    if (layoutElement) {
      layoutElement.classList.toggle("blur");
    }
  };

  return (
    <ReactModal
      closeTimeoutMS={200}
      isOpen={isOpen}
      onClose={onClose}
      onAfterOpen={() => {
        handleToggleClass();
      }}
      onAfterClose={() => {
        handleToggleClass();
        onAfterClose();
      }}
      overlayClassName={"drawer-overlay"}
      className={`${drawerClass.base} ${drawerClass[from]}`}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      preventScroll={true}
      appElement={document.getElementById("root")}
    >
      <AnimatePresence mode="wait">
        {isOpen && (
          <motion.div
            variants={drawerAnimation[from]}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div className={`inner ${innerClass}`}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </ReactModal>
  );
}
